if (new URLSearchParams(location.search).get('ein'))
  document.body.classList.add('has-ein')